import { EAssetType } from 'constants/enums';
import { ROLLING_OFFER_DEFAULTS } from 'views/OfferDesign/OfferDesign.consts';

import {
  PERCENTAGE_LEFT_ICON,
  PERCENTAGE_LEFT_ICON_STYLES
} from '../FormFields.consts';
import {
  GradientFieldConfig,
  NumberFieldConfig,
  TextFieldConfig,
  UploadFieldConfig
} from '../FormFields.types';

export { ROLLING_OFFER_DEFAULTS };

export const COLLECT_TEXT_FIELD: TextFieldConfig = {
  label: 'Free Offer Text',
  name: 'collectText',
  placeholder: 'FREE',
  defaultValue: ''
};

export const BG_BORDER_ROW_GRADIENT: GradientFieldConfig = {
  header: 'Background Color',
  name: 'backgroundColor',
  fallback: ROLLING_OFFER_DEFAULTS.backgroundColor,
  required: true,
  dataTestId: 'offer-design-rolling-offer-main-background-color-input'
};

export const BG_BORDER_ROW_WIDTH: NumberFieldConfig = {
  label: 'Background opacity',
  name: 'backgroundOpacity',
  min: 0,
  max: 100,
  isRequired: true,
  leftIcon: PERCENTAGE_LEFT_ICON,
  leftIconStyles: PERCENTAGE_LEFT_ICON_STYLES
};

export const BORDER_ROW_GRADIENT: GradientFieldConfig = {
  header: 'Border Color',
  name: 'borderColor',
  fallback: ROLLING_OFFER_DEFAULTS.borderColor,
  dataTestId: 'offer-design-rolling-offer-main-border-color-input'
};

export const BORDER_ROW_WIDTH: NumberFieldConfig = {
  label: 'Offer border width',
  name: 'borderWidth',
  min: 0,
  max: 8,
  isRequired: true
};

export const SUB_OFFER_BG_FIELDS: GradientFieldConfig[] = [
  {
    header: 'Offers background color',
    name: 'offersBackgroundColor',
    fallback: ROLLING_OFFER_DEFAULTS.subOfferBackgroundColor,
    required: true,
    dataTestId: 'offer-design-rolling-offer-sub-offers-background-color-input'
  }
];

export const MAIN_UPLOAD_FIELDS: UploadFieldConfig[] = [
  {
    title: 'Offer Header Image',
    fieldName: 'headerImage',
    forceType: EAssetType.OFFER_HEADER,
    tooltip: 'Upload an image for the offer header.'
  },
  {
    title: 'Arrows Image',
    fieldName: 'arrowImage',
    forceType: EAssetType.GENERAL,
    tooltip: 'Upload a 1:1 ratio image with an arrow pointing to the right.'
  },
  {
    title: 'Scroll Arrow Image',
    fieldName: 'scrollArrowImage',
    forceType: EAssetType.GENERAL,
    tooltip: 'Optional. Upload a right-pointing arrow image. The system mirrors it for the opposite direction. When no image is provided, default arrows are used.',
    disabled: (values) => !values.enableScroll
  },
  {
    title: 'Offer Background Image (Vertical)',
    fieldName: 'backgroundImage',
    forceType: EAssetType.BG_BUNDLE,
    tooltip: 'Upload a vertical background image for the rolling offer.'
  },
  {
    title: 'Offer Background Image (Horizontal)',
    fieldName: 'horizontalBackgroundImage',
    forceType: EAssetType.BG_BUNDLE,
    tooltip: 'Upload a horizontal background image for the rolling offer.'
  }
];
